import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import GlobalLoader from "./components/common/Loader";
// ask if you want to leave the webpage if user close the webpage.
// window.onbeforeunload = () => {
//     return true; 
// }
if(!window.localStorage){
    window.alert("Sorry! No Web Storage support..");
}

export default function App(){
    return(
        <>
        <RouterProvider router = {router} fallbackElement = {<GlobalLoader/>}/>
        </>
    );
}
